import script from "./TaskListTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./TaskListTable.vue?vue&type=script&setup=true&lang=ts"

import "./TaskListTable.vue?vue&type=style&index=0&id=2352c52f&scoped=true&lang=css"
import "./TaskListTable.vue?vue&type=style&index=1&id=2352c52f&lang=css"

import exportComponent from "/Users/ra1to/Desktop/web_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2352c52f"]])

export default __exports__